var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useRegistrationForm from "../../../../../hooks/useRegistrationForm";
import { useEffect, useState } from "react";
export var enrichRegistrationFormPropsMsdGSF2025 = function () {
    var _a;
    var _b = useState(false), showAllInputs = _b[0], setShowAllInputs = _b[1];
    var _c = useState([]), filteredEpisodes = _c[0], setFilteredEpisodes = _c[1];
    var _d = useState(), singleEpisodeId = _d[0], setSingleEpisodeId = _d[1];
    var onChange = function (changed) {
        if (!showAllInputs && changed["gsf2025_episodes_id"] !== undefined) {
            setShowAllInputs(true);
            setSingleEpisodeId(changed["gsf2025_episodes_id"]);
        }
        else if (changed["gsf2025_episodes_id"]) {
            setSingleEpisodeId(changed["gsf2025_episodes_id"]);
        }
    };
    var _e = useRegistrationForm(), contents = _e.contents, allCountries = _e.allCountries, hasInternal = _e.hasInternal, isInternalUser = _e.isInternalUser, languages = _e.languages, getRegistrationFormProps = _e.getRegistrationFormProps, episodes = _e.episodes;
    useEffect(function () {
        if (episodes)
            setFilteredEpisodes(episodes.filter(function (item) { return item.is_subscriptions_open; }));
    }, [episodes]);
    useEffect(function () {
        if (filteredEpisodes.length === 1) {
            setShowAllInputs(true);
            setSingleEpisodeId(filteredEpisodes[0].id);
        }
    }, [filteredEpisodes]);
    var _f = contents, error_country_required = _f.error_country_required, error_lastname_required = _f.error_lastname_required, error_firstname_required = _f.error_firstname_required, error_language_required = _f.error_language_required, email = _f.email, affiliation = _f.affiliation, phone = _f.phone, country_of_work = _f.country_of_work, language = _f.language, internal = _f.internal, firstname = _f.firstname, lastname = _f.lastname, country = _f.country, choose_password_title = _f.choose_password_title, error_affiliation_required = _f.error_affiliation_required, error_specialty_required = _f.error_specialty_required, password_confirmation = _f.password_confirmation, error_password_required = _f.error_password_required, error_psw_do_not_match = _f.error_psw_do_not_match, specialty = _f.specialty, error_email_invalid = _f.error_email_invalid, error_email_required = _f.error_email_required, internal_true_value_label = _f.internal_true_value_label, internal_false_value_label = _f.internal_false_value_label, field_required = _f.field_required, stream = _f.stream;
    var inputs = [];
    inputs.push({
        type: (filteredEpisodes === null || filteredEpisodes === void 0 ? void 0 : filteredEpisodes.length) === 1 ? "hidden" : "select",
        label: stream,
        name: "gsf2025_episodes_id",
        rules: [
            {
                required: true,
                message: field_required
            }
        ],
        value: (filteredEpisodes === null || filteredEpisodes === void 0 ? void 0 : filteredEpisodes.length) === 1 ? filteredEpisodes[0].id : null,
        options: filteredEpisodes.map(function (episode) { return ({
            value: episode.id,
            label: episode.title
        }); })
    });
    if (hasInternal && showAllInputs) {
        inputs.push({
            type: "select",
            label: internal,
            required: true,
            name: "is_internal",
            rules: [
                {
                    required: true,
                    message: ""
                }
            ],
            options: [
                {
                    value: 1,
                    label: internal_true_value_label
                },
                {
                    value: 0,
                    label: internal_false_value_label
                }
            ]
        });
    }
    var countriesSelect = {
        type: "select",
        label: country,
        required: true,
        showSearch: true,
        name: "country_id",
        rules: [
            {
                required: true,
                message: error_country_required
            }
        ],
        //@ts-ignore
        options: (_a = filteredEpisodes.find(function (episode) { return episode.id === singleEpisodeId; })) === null || _a === void 0 ? void 0 : _a.available_countries
    };
    if (isInternalUser && showAllInputs) {
        countriesSelect = {
            type: "select",
            label: country_of_work,
            required: true,
            showSearch: true,
            name: "country_id_of_work",
            rules: [
                {
                    required: true,
                    message: error_country_required
                }
            ],
            options: allCountries
        };
    }
    if (showAllInputs)
        inputs.push(countriesSelect);
    var languageInput = {
        type: "hidden",
        name: "lang_id",
        value: languages[0].value
    };
    if (languages.length > 1 && showAllInputs) {
        languageInput = {
            type: "select",
            label: language,
            required: true,
            name: "lang_id",
            options: languages,
            rules: [
                {
                    required: true,
                    message: error_language_required
                }
            ]
        };
    }
    if (showAllInputs)
        inputs.push(languageInput);
    if (showAllInputs) {
        inputs = __spreadArray(__spreadArray([], inputs, true), [
            {
                type: "text",
                label: firstname,
                required: true,
                name: "firstname",
                rules: [
                    {
                        required: true,
                        message: error_firstname_required
                    }
                ]
            },
            {
                type: "text",
                label: lastname,
                required: true,
                name: "lastname",
                rules: [
                    {
                        required: true,
                        message: error_lastname_required
                    }
                ]
            },
            {
                type: "text",
                label: specialty,
                required: true,
                name: "specialty",
                rules: [
                    {
                        required: true,
                        message: error_specialty_required
                    }
                ]
            },
            {
                type: "text",
                label: affiliation,
                required: true,
                name: "affiliation",
                rules: [
                    {
                        required: true,
                        message: error_affiliation_required
                    }
                ]
            },
            {
                type: "email",
                label: email,
                required: true,
                name: "email",
                rules: [
                    { type: "email", message: error_email_invalid },
                    {
                        required: true,
                        message: error_email_required
                    }
                ]
            },
            {
                type: "password",
                label: choose_password_title || "Choose your password",
                required: true,
                name: "password",
                rules: [
                    {
                        required: true,
                        message: error_password_required
                    }
                ]
            },
            {
                type: "password",
                label: password_confirmation,
                required: true,
                name: "password_confirmation",
                rules: [
                    {
                        required: true,
                        message: error_psw_do_not_match
                    }
                ]
            },
            {
                type: "text",
                label: phone,
                name: "phone"
            },
            {
                type: "hidden",
                name: "change_password_required",
                value: false
            }
        ], false);
    }
    return {
        inputs: getRegistrationFormProps({ inputs: inputs }).inputs,
        onChange: function (changedValues) {
            getRegistrationFormProps({ inputs: inputs }).onChange(changedValues);
            var newChangedValues = __assign(__assign({}, changedValues), { episodes_id: [changedValues["episodes_id"]] });
            onChange(newChangedValues);
        }
    };
};
